import { PreparedWorkload } from '@cast/split-me/features/workload-optimization';
import { WorkloadsSection } from '@cast/split-me/features/cluster/workload-optimization';
import { useCluster } from '@cast/shared-cluster-context-data-access';

import { WORKLOAD_CATEGORIES, WORKLOAD_VIEWS } from '../../../_constants';
import { inventoryWorkloadsTableKeys, tableCacheKeys } from '../../../consts';
import { buildInventoryWorkloadViewPath } from '../../../navigation';

export const InventoryWorkloadsListSavings = () => {
  const { cluster } = useCluster();

  const getWorkloadLink = (workload: PreparedWorkload) =>
    buildInventoryWorkloadViewPath({
      clusterId: cluster.id,
      workloadId: workload.id,
      category: WORKLOAD_CATEGORIES.SAVINGS,
      view: WORKLOAD_VIEWS.DASHBOARD,
    });

  return (
    <WorkloadsSection
      urlKey={inventoryWorkloadsTableKeys.SAVINGS}
      cacheKey={tableCacheKeys.INVENTORY_WORKLOADS.SAVINGS}
      getWorkloadLink={getWorkloadLink}
    />
  );
};
